import React from 'react';
import i18n from 'i18next';

import {SecondaryButton} from 'components';

import DownloadIconSrc from 'assets/icons/download.svg';

type Props = {
  onClick: () => void;
};

export default function DownloadButton({onClick}: Props) {
  return (
    <SecondaryButton
      className="ml-2"
      style={{padding: '0.25rem'}}
      onClick={onClick}
    >
      <div className="flex">
        <span className="py-2 pl-2 font-semibold">
          {i18n.t('wisbitPage.index.downloadResults')}
        </span>
        <img
          src={DownloadIconSrc}
          alt={i18n.t('wisbitPage.index.downloadResults')}
        />
      </div>
    </SecondaryButton>
  );
}
